/*
    Replaces any verbatim 'plus', 'minus' and 'asterisk' with '+', '-' and '*'
 */
export function formatInheritedFactors(value: string) {
    if (!value) return "";
    return value.replace(/minus/g, "-").replace(/plus/g, "+").replace(/asterisk/g, "*");
}